function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { InfaceSDK } from '@inface-sdk/common';
import { RawApi, SDKApi } from './interface/index';
import '@inface-sdk/livestream';
import '@inface-sdk/instant-message';
import { WebPush } from './web-push/web-push.class';
import { TokenBuilder } from './push-tokens';
var webPushModule = SDKApi();
var infaceModule = InfaceSDK.register({
  name: 'web-push',
  version: process.env.__web_push_version || '__web_push_version',
  description: process.env.__web_push_description || '__web_push.description',
  rawApis: RawApi(webPushModule),
  sdkApis: [].concat(_toConsumableArray(webPushModule), [{
    name: 'WebPush',
    action: WebPush
  }, {
    name: 'TokenBuilder',
    action: TokenBuilder
  }])
});
export default infaceModule;